// Imports
import Vue from 'vue'
import VueRouter from 'vue-router'

// Pages
import ASolution from '@/pages/a-solution/a-solution'
import About from '@/pages/about/about'
import Challenges from '@/pages/challenges/challenges'
import Home from '@/pages/home/home'
import Instructions from '@/pages/instructions/instructions'
import PageNotFound from '@/pages/404/404'
import ServicesSupplies from '@/pages/services-supplies/services-supplies'

// Resources
import scrollBehavior from '@/shared/functionality/scroll-behavior'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      navigation: true,
      component: Home
    },
    {
      path: '/challenges',
      name: 'Challenges',
      navigation: true,
      component: Challenges
    },
    {
      path: '/a-solution',
      name: 'A Solution',
      navigation: true,
      component: ASolution
    },
    {
      path: '/services-supplies',
      name: 'Services',
      navigation: true,
      component: ServicesSupplies,
      children: [
        {
          name: 'Supplies: Spawn, Logs, and Substrate',
          path: '/services-supplies#supplies'
        },
        {
          name: 'Consultation and On-Site Inoculation',
          path: '/services-supplies#consult'
        },
        {
          name: 'Partnership Matching',
          path: '/services-supplies#partnership'
        }
      ]
    },
    {
      path: '/instructions',
      name: 'Instructions',
      navigation: true,
      component: Instructions
    },
    {
      path: '/about',
      name: 'About',
      navigation: true,
      component: About
    },
    {
      path: '/*',
      name: '404',
      navigation: false,
      component: PageNotFound
    }
  ],
  scrollBehavior
})

// // Scroll to the top when switching pages
// router.beforeEach((to, from, next) => {
//   window.scrollTo(0, 0)
//   next()
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js